import { createSlice } from "@reduxjs/toolkit";

import { getChefsList } from "../../../../api/chef";
import { sliceHandler } from "../../utils";

const getChefSlice = createSlice(
  sliceHandler({
    name: 'getChef',
    action: 'getChefSlice',
    success: 'getChefSliceSuccess',
    failure: 'getChefSliceFailure',
    reset: 'getChefSliceReset'
  })
);

const getChefAction: any = getChefSlice.actions;
const getChefHandler: any = (page: number | null, limit: number | string, filter: number, search: string, sortField: any, sortDirection: any) => async (dispatch: any) => {
  try {
    dispatch(getChefAction.getChefSlice());
    const response: any = await getChefsList(page ?? 1, limit, filter, search, sortField, sortDirection);
    dispatch(getChefAction.getChefSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefAction.getChefSliceFailure(e?.response?.data));
  }
};

export {
  getChefHandler,
  getChefAction
}
export default getChefSlice.reducer;